import React, { useState } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import SpocAccordion from "../custom/SpocAccordion";
import SpocAccordionSummary from "../custom/SpocAccordionSummary";
import SpocAccordionDetails from "../custom/SpocAccordionDetails";
import renderHTML from "lib/render-html";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    heading: {
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightRegular,
    },
  })
);
const About: React.FC<AboutProps> = ({ content }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(true);

  return (
    <Box paddingY={[3, 4, 5, 6]} component="section">
      <Container>
        <SpocAccordion
          square
          expanded={expanded}
          onChange={() => setExpanded((prev) => !prev)}
          TransitionProps={{ unmountOnExit: true }}
        >
          <SpocAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="about-content"
            id="about-header"
          >
            <Typography className={classes.heading}>
              {renderHTML(content.heading)}
            </Typography>
          </SpocAccordionSummary>
          <SpocAccordionDetails>
            <Typography variant="body1" component="span">
              {renderHTML(content.paragraph)}
            </Typography>
          </SpocAccordionDetails>
        </SpocAccordion>
      </Container>
    </Box>
  );
};

export default About;
